import * as reportActionTypes from "./actionTypes";

export function getReport(payload) {
    return {
        type: reportActionTypes.GET_WARRANTIES_REPORT,
        payload,
    };
}

export function resetReport() {
    return {
        type: reportActionTypes.RESET_WARRANTIES_REPORT,
    };
}
export function getReportSuccess(data) {
    return {
        type: reportActionTypes.GET_WARRANTIES_REPORT_SUCCESS,
        ...data,
    };
}

export function getReportFailure(errors) {
    return {
        type: reportActionTypes.GET_WARRANTIES_REPORT_FAILURE,
        errors,
    };
}